import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';
import { useAuth } from './useAuth';
import { useOnboardingNavRefresh } from '../context/OnboardingNavRefreshContext';
import { isOnboardingRequiredComplete } from '../config/onboardingSteps';

/**
 * When all required setup steps are satisfied (auto-detected and/or manual), the “Setup guide”
 * item should be hidden in the main nav. Default: show until we know (incomplete users keep the link).
 */
export function useShowOnboardingNav(): boolean {
  const { activeMarinaId } = useAuth();
  const { tick } = useOnboardingNavRefresh();
  const [show, setShow] = useState(true);

  const refresh = useCallback(() => {
    if (activeMarinaId === null) {
      setShow(true);
      return;
    }
    api
      .getOnboarding()
      .then((data) => {
        setShow(
          !isOnboardingRequiredComplete(
            data.detected ?? {},
            data.onboarding_progress ?? {},
          ),
        );
      })
      .catch(() => setShow(true));
  }, [activeMarinaId]);

  useEffect(() => {
    void refresh();
  }, [refresh, tick]);

  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === 'visible') {
        void refresh();
      }
    };
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, [refresh]);

  return show;
}
